import { InfoCard } from '@rsa-digital/evo-shared-components/components/InfoCard';
import colors from '@rsa-digital/evo-shared-components/helpers/colors';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing, {
  spacingWithBorder,
} from '@rsa-digital/evo-shared-components/helpers/spacing';
import { fontWeightMedium } from '@rsa-digital/evo-shared-components/theme/RSA/fonts';
import styled from 'styled-components';

const BORDER_PX = 1;

export const Container = styled.div`
  background-color: ${colors.neutral08};
  border: ${BORDER_PX}px solid ${colors.cardBorder};

  margin: ${spacing(1)} 0;

  ${mediaQuery.tabletLandscape`
    margin: ${spacing(2)} 0;
  `}
`;

export const Token = styled.div`
  background: #d9fffb;
  border-radius: 25px;
  margin: ${spacingWithBorder(4, BORDER_PX)} ${spacingWithBorder(3, BORDER_PX)} 0;
  max-width: 213px;
  padding: ${spacing(1)} ${spacing(2)};
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    margin: 0;
    font-size: 1rem; //16px;
    font-weight: ${fontWeightMedium};
  }

  ${mediaQuery.tabletLandscape`
    margin: ${spacingWithBorder(4, BORDER_PX)} ${spacingWithBorder(4, BORDER_PX)} 0;
  `}
`;

export const StyledInfoCard = styled(InfoCard)<{ hasToken?: boolean }>`
  border: none;
  margin: 0;
  ${({ hasToken }) => (hasToken ? `height: calc(100% - 67px);` : `height: 100%;`)}

  ${mediaQuery.tabletLandscape`
    margin: 0;
  `}
`;
